import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// The page-wide modal: shown when content is loaded into its Turbo Frame
// (e.g. an edit form), emptied when closed.
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.modal = Modal.getOrCreateInstance(this.element)
  }

  disconnect() {
    this.modal.dispose()
  }

  open() {
    this.modal.show()
  }

  clear() {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.replaceChildren()
  }
}
